import { render, staticRenderFns } from "./HofladenMain.vue?vue&type=template&id=41ff38e2&"
import script from "./HofladenMain.vue?vue&type=script&lang=js&"
export * from "./HofladenMain.vue?vue&type=script&lang=js&"
import style0 from "./HofladenMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports